<div class="mwp-modal">
  <div>
    <div class="modal-header w-100 d-flex justify-content-center align-items-center">
      <div class="title d-inline-flex w-100">
        @if (!fileUploadDialogModel.memberName) {
          <div>
            <mwp-text-translate text="Upload Documents" jsonKey="fileUpload1" />
          </div>
        }
        @if (fileUploadDialogModel.memberName) {
          <div class="d-inline-flex">
            <div>
              <mwp-text-translate text="Upload Documents for" jsonKey="fileUpload2" />
            </div>
            <div class="ms-1">
              {{ fileUploadDialogModel.memberName }}
            </div>
          </div>
        }
      </div>
    </div>
    @if (displayFlynnCustomMessage) {
      <div class="info-box m-3">
        <div class="mb-3">
          <mwp-text-translate text="Spouse requires One document from both Column A and Column B:" jsonKey="fileUpload4" />
        </div>
        <div class="document-column-container ">
          <div class="document-column">
            <div class="fw-bold p-3">
              <mwp-text-translate text="Column A:" jsonKey="columnA" />
            </div>
            <div class="ps-3">
              <ul>
                <li>
                                <mwp-text-translate text="Copy of page one of your current year or previous year tax return showing you filed as married (you may cross out wage
                                        and social security number information)" jsonKey="fileUpload5" />
                  </li>
                  <li>
                    <mwp-text-translate text="Copy of marriage certificate" jsonKey="copyOfMarriageCertificate" />
                  </li>
                </ul>
              </div>
            </div>
            <div class="document-column">
              <div class="fw-bold p-3">
                <mwp-text-translate text="Column B:" jsonKey="columnB" />
              </div>
              <div class="ps-3">
                <ul>
                  <li>
                    <mwp-text-translate text=" A copy of a driver's license (must have the same address as associate)" jsonKey="fileUpload6" />
                  </li>
                  <li>
                    <mwp-text-translate text="Proof of a common ownership of a motor vehicle" jsonKey="fileUpload7" />
                  </li>
                  <li>
                    <mwp-text-translate text="Proof of joint bank accounts or credit accounts (current)" jsonKey="fileUpload8" />
                  </li>
                  <li>
                    <mwp-text-translate text="Assignment of a durable property power of attorney or health care power of attorney" jsonKey="fileUpload9" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="modal-note">
      <mwp-text-translate text="The following file types are accepted: .pdf, .png, .jpg, .jpeg. Each file must be smaller than 5MB and total file size less than 25MB." jsonKey="fileUpload3" />
    </div>
    <div>
      <mwp-file-upload [displayFileSizeText]="false" (filesEmit)="updateFiles($event)" [isModal]="true" />
      @if (displayConfigError) {
        <div class="mb-3 message-container red">
          <mwp-text-translate text="Cannot Save documents as dialog is not configured properly. Please notify the Administrator of this issue." jsonKey="fileUpload10" />
        </div>
      }
      <div class="d-flex justify-content-end w-100 p-3">
        <button class="mwp-button-secondary me-3" (click)="closeDialog()">
          <mwp-text-translate text="Cancel" jsonKey="fileUpload11" />
        </button>
        <button class="mwp-button-save" [disabled]="!isValid" (click)="saveDocuments()">
          <mwp-text-translate text="Upload Document Batch" jsonKey="fileUpload11" />
        </button>
      </div>
    </div>
  </div>